import { extractContentfromHtml } from "@ms/uno-utilities/lib/local/HtmlUtilities";
/** Cache for notes preview */ const notesPreviewCache = {};
/**
 * Extract plain text from HTML notes for display in task card preview.
 * This is memoized to avoid re-parsing the same HTML string multiple times.
 * @param htmlString HTML string to extract plain text from
 * @param id ID of the task
 */ export function extractContentFromHtmlForNotesPreview(htmlString, id) {
    if (!htmlString || !id) {
        return "";
    }
    // If htmlString is updated, update the cached plain text
    if (notesPreviewCache[id]?.htmlString !== htmlString) {
        notesPreviewCache[id] = {
            htmlString,
            plainText: extractContentfromHtml(htmlString)
        };
    }
    return notesPreviewCache[id].plainText;
}
